/* eslint-disable react/prop-types */
import React from "react";
import {
  makeStyles,
  Box,
  Typography,
  Button,
  withStyles,
} from "@material-ui/core";
import { HiPencil } from "react-icons/hi";
import ScenarioCardValueItem from "./ScenarioCardValueItem";
import CompetitorExportExceButton from "../competitors_scenario_component/CompetitorExportExceButton";

const useStyles = makeStyles(() => ({
  rowContainer: {
    height: "100%",
    display: "grid",
    backgroundColor: "#fff",
    gridTemplateColumns: "minmax(400px,5fr) 4fr",
    position: "relative",
    "@media (min-width: 1580px)": {
      gridTemplateColumns: "4fr 6fr",
    },
  },
  scenarioDataContainer: {
    display: "grid",
    height: "calc(100% - 50px)",
    width: "calc(100% - 40px)",
    margin: "25px 5px 25px 35px",
    columnGap: "10px",
    gridTemplateRows: "repeat(4,1fr)",
    // gridTemplateAreas:`
    // "name         name      edit"
    // "cycleLabel   .         ."
    // "createdBy    comments  ."
    // "priceChange  comments  ."`,
    gridTemplateAreas: `
      "name         name       edit"
      "cycleLabel   cycleLabel ."
      "createdBy    createdBy  ."
      "comments     comments   ."`,
    gridTemplateColumns: "4fr 3fr 1fr",
    overflow: "hidden",
    fontSize: "14px",
    color: "#646464",
    borderRight: "1px solid #e2e2e2",
  },
  baseScenarioDataContainer: {
    gridTemplateRows: "repeat(5,1fr)",
    // gridTemplateAreas: `
    //   "name         name      edit"
    //   "cycleLabel   .         ."
    //   "cycleType    .         ."
    //   "createdBy    comments  ."
    //   "priceChange  comments  ."`,
    gridTemplateAreas: `
      "name         name          edit"
      "cycleLabel   cycleLabel    ."
      "cycleType    cycleType     ."
      "createdBy    createdBy     createdBy"
      "comments     comments      comments"`,
  },
  textName: {
    whiteSpace: "nowrap",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  editContainer: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "10px",
  },
  editText: {
    fontSize: "14px",
    color: "#646464",
    marginLeft: "3px",
  },
  textStyleTop: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  textStyleBottom: {
    fontSize: "14px",
    color: "#646464",
  },
  iconStyle: {
    marginTop: "2px",
    width: "16px",
    height: "16px",
  },
  valuesContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(150px,1fr))",
    gridTemplateRows: "1fr",
    alignItems: "center",
    overflow: "hidden",
    width: "calc(100% - 20px)",
    height: "80%",
    margin: "auto",
    padding: "0 10px",
    "@media (max-width: 1580px)": {
      gridTemplateColumns: "repeat(2, minmax(150px,1fr))",
      gridTemplateRows: "1fr 1fr",
    },
  },
}));

export default function CompetitorScenarioCard({
  name,
  cycleLabel,
  cycleType,
  ownerLabel,
  // pricePercentageModification,
  comment,
  handleScenarioClick,
  isBaseScenario = false,
  customCompetitorData = null,
  customCompetitorSliderData = null,
  marketShare,
  percentageMarketShare = null,
  salesOut,
  percentageSalesOut = null,
  sellOut,
  percentageSellOut = null,
  margin,
  percentageMargin = null,
}) {
  const classes = useStyles();
  const StylePromotiondButton = withStyles(() => ({
    root: {
      width: "22px",
      height: "22px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "white",
      },
    },
  }))(Button);
  return (
    <Box className={classes.rowContainer}>
      <Box
        className={`${classes.scenarioDataContainer} ${isBaseScenario ===
          true && classes.baseScenarioDataContainer}`}
      >
        <Typography
          variant="body1"
          className={`${classes.textStyleTop} ${classes.textName}`}
          style={{ gridArea: "name" }}
        >
          {name}
        </Typography>
        <Typography
          variant="body1"
          className={classes.textStyleTop}
          style={{ gridArea: "cycleLabel" }}
        >
          {cycleLabel}
        </Typography>
        {isBaseScenario === true && (
          <Typography
            variant="body1"
            className={classes.textStyleTop}
            style={{ gridArea: "cycleType" }}
          >
            {cycleType}
          </Typography>
        )}
        <Typography
          variant="body1"
          className={classes.textStyleBottom}
          style={{ gridArea: "createdBy" }}
        >
          Created by {ownerLabel}
        </Typography>
        {/* <Typography
          variant="body1"
          className={classes.textStyleBottom}
          style={{ gridArea: "priceChange" }}
        >
          Price change {pricePercentageModification} %
        </Typography> */}
        <Box
          className={classes.textContainerComments}
          style={{ gridArea: "comments" }}
        >
          <Typography variant="body1" className={classes.textStyleBottom}>
            {comment !== "" ? comment : "Comments..."}
          </Typography>
        </Box>
        <Box className={classes.editContainer} style={{ gridArea: "edit" }}>
          <StylePromotiondButton disableRipple onClick={handleScenarioClick}>
            <HiPencil className={classes.iconStyle} />
            <Typography variant="body1" className={classes.editText}>
              Edit
            </Typography>
          </StylePromotiondButton>
        </Box>
      </Box>

      <Box className={classes.valuesContainer}>
        <ScenarioCardValueItem
          text="Market Share"
          percentageUnits="pp"
          value={marketShare}
          percentage={percentageMarketShare}
        />
        <ScenarioCardValueItem
          text="Sales Out"
          value={salesOut}
          percentage={percentageSalesOut}
        />
        <ScenarioCardValueItem
          text="Sell out"
          value={sellOut}
          percentage={percentageSellOut}
        />
        <ScenarioCardValueItem
          text="Margin"
          value={margin}
          percentage={percentageMargin}
        />
      </Box>

      {isBaseScenario === false && (
        <CompetitorExportExceButton
          competitorScenarioData={customCompetitorData}
          competitorSliderData={customCompetitorSliderData}
        />
      )}
    </Box>
  );
}
